"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ScrollTo = /*#__PURE__*/function () {
  function ScrollTo(source) {
    _classCallCheck(this, ScrollTo);

    this.source = source;
    this.target = document.getElementById(this.source.dataset.target) || null;
    this.container = document.getElementById(this.source.dataset.container);
    this.listen();
  }

  _createClass(ScrollTo, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      var listener = this.container ? this.container : window;

      if (this.target) {
        this.source.addEventListener('click', function (event) {
          event.preventDefault();
          var top = _this.container ? _this.target.offsetTop : listener.scrollY + _this.target.getBoundingClientRect().top;
          listener.scroll({
            top: top,
            behavior: 'smooth'
          });
        });
      }
    }
  }]);

  return ScrollTo;
}();

document.addEventListener('DOMContentLoaded', function () {
  var sources = _toConsumableArray(document.getElementsByClassName('js-scroll-to'));

  if (sources.length) {
    sources.forEach(function (s) {
      return new ScrollTo(s);
    });
  }
});